/**
 * Get the current locale for formatting numbers, dates, and currency.
 * 
 * Priority order:
 * 1. Browser's primary language (navigator.language)
 * 2. Browser's language preferences (navigator.languages[0])
 * 3. OS locale detection via Intl.DateTimeFormat
 * 4. Default fallback to 'en-US'
 * 
 * @returns The locale string (e.g., 'en-US', 'es-MX', 'fr-FR')
 */
export function getLocale(): string {

  // Client-side locale detection
  if (typeof window !== 'undefined' && window.navigator) {
    // 1. Check browser's primary language
    if (window.navigator.language) {
      return window.navigator.language
    }

    // 2. Check browser's language preferences array
    if (window.navigator.languages && window.navigator.languages.length > 0) {
      return window.navigator.languages[0]
    }
  }

  // 3. Try to detect OS locale via Intl.DateTimeFormat (works in both browser and Node.js)
  try {
    // This will use the system's default locale
    const osLocale = new Intl.DateTimeFormat().resolvedOptions().locale
    if (osLocale) {
      return osLocale
    }
  } catch (error) {
    // Intl.DateTimeFormat might not be available in some environments
    console.warn('Could not detect OS locale:', error)
  }

  // 4. Default fallback
  return 'en-US'
}